import { ElementTypes } from '../element-types';

export class DatePicker {
  static readonly StartDate: string = `${ElementTypes.DatePicker}-start-date`;
  static readonly EndDate: string = `${ElementTypes.DatePicker}-end-date`;
  static readonly SingleDate: string = `${ElementTypes.DatePicker}-single-date`;
}
